import React from 'react';
import { MdErrorOutline } from 'react-icons/md';
import { Container, Message } from './styles';

const NotAuthenticated: React.FC = () => {
  return (
    <Container>
      <MdErrorOutline size={36} />
      <Message>Usuário não autenticado!</Message>
    </Container>
  );
};

export default NotAuthenticated;
